/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { If, Then, Else } from "react-if";
import { useParams } from "react-router-dom";
import { Text } from "@nordcloud/gnui";
import { useListReservationCoveredInstancesQuery } from "~/generated/graphql";
import { Pagination, ReactTable, PaginationState, NoData } from "~/components";
import { useQueryState } from "~/hooks";
import { isNotEmpty } from "~/tools";
import { EstateRecordsColumns } from "./EstateRecordsColumns";

type RouteParams = {
  nordcloudId: string;
};

export function BenefitedEstateRecords() {
  const { nordcloudId } = useParams<RouteParams>();
  const {
    state: { page: pageCI, limit: limitCI },
  } = useQueryState<PaginationState>();

  const { data: reservationCoveredInstancesData } =
    useListReservationCoveredInstancesQuery({
      variables: { reservationId: nordcloudId, page: pageCI, limit: limitCI },
    });

  const estateRecordsColumns = React.useMemo(() => {
    return EstateRecordsColumns;
  }, []);

  const showEstateRecords = isNotEmpty(
    reservationCoveredInstancesData?.listReservationCoveredInstances
      ?.instances || []
  );

  return (
    <If condition={showEstateRecords}>
      <Then>
        <ReactTable
          columns={estateRecordsColumns}
          sort={false}
          data={
            reservationCoveredInstancesData?.listReservationCoveredInstances
              ?.instances || []
          }
          striped
        />
        <Pagination
          count={
            reservationCoveredInstancesData?.listReservationCoveredInstances
              ?.count || 0
          }
        />
      </Then>
      <Else>
        <NoData message={<Text>There are no estate records.</Text>} />
      </Else>
    </If>
  );
}
